import { ComponentChildren } from "preact";

interface ContainerProps {
  className?: string;
  children?: ComponentChildren;
}

const Container = ({ children, className }: ContainerProps) => {
  return (
    <div
      className={`lc-mx-6 lg:lc-mx-9 lc-py-8 md:lc-py-10 lc-w-full lc-min-h-[500px] md:lc-min-h-[700px] md:lc-max-w-6xl lc-flex lc-flex-col lc-gap-8 lg:lc-gap-16 lc-relative ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;
